import React, { Suspense } from "react";
import Skeleton from "@mui/material/Skeleton";

const FixInput = React.lazy(() => import("./FixInput"));

export const LazyFixInput = ({
  onSubmit,
  overrideFixValue,
  memoryError,
  onLoadDictionary,
}: {
  onSubmit: (value: string) => void;
  overrideFixValue: string;
  memoryError?: string;
  onLoadDictionary?: (
    dictionary: { filename: string; content: string } | undefined,
  ) => void;
}) => {
  return (
    <Suspense fallback={<Skeleton height={200} />}>
      <FixInput
        memoryError={memoryError}
        overrideFixValue={overrideFixValue}
        onLoadDictionary={onLoadDictionary}
        onSubmit={onSubmit}
      />
    </Suspense>
  );
};
